import videojs, { VideoJsPlayer } from 'video.js';

import type QualityLevelsManagerPlugin from '@src/plugins/QualityLevelsManagerPlugin';
import { Event } from '@src/types/event';

import type QualityLevelMenuButton from './QualityLevelMenuButton';

const MenuItem = videojs.getComponent('MenuItem');

export type MenuItemOptions = {
  value: number | 'auto';
  label: string;
  selected?: boolean;
  selectable: true;
  multiSelectable: false;
};

class QualityLevelMenuItem extends MenuItem {
  menuButton: QualityLevelMenuButton;
  options_!: MenuItemOptions;
  constructor(
    player: VideoJsPlayer,
    options: MenuItemOptions,
    context: { menuButton: QualityLevelMenuButton }
  ) {
    super(player, options);

    this.menuButton = context.menuButton;
  }

  handleClick(evt: videojs.EventTarget.Event) {
    super.handleClick(evt);

    this.menuButton.unpressButton();
    this.menuButton.resetItemsSelectedState();

    this.player_.trigger(Event.X_CLICK_QUALITYLEVEL, {
      value: this.options_.value,
      label: this.options_.label,
    });

    this.selected(true);

    (
      this.player_.qualityLevelsManagerPlugin as QualityLevelsManagerPlugin
    )?.setQualityLevel(this.options_.value);
  }
}

videojs.registerComponent('QualityLevelMenuItem', QualityLevelMenuItem);

export default QualityLevelMenuItem;
